export const FEATURE_NAME = '@zerops/zerops/features/github-repo-form';
